// initialed state
export const initialState = () => ({
	tempBlocks: {},
	moveNodeActive: false,
	nodeIdToMove: null,
	moveNodeLoading: false,
	tempBlock: null,
	isEndRunLoading: false,
	shortcutCommand: null,
});

const state = initialState();

export default state;
